import React from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import { Chart, registerables } from "chart.js";
import { api } from "api";
import moment from "moment";
import { ChartLine } from "./ChartLine";
import { InformationCard } from "./InformationCard";
import totalSVG from "../../../../../assets/img/total-colab.svg";
import activosSVG from "../../../../../assets/img/activos-colab.svg";
import despidosSVG from "../../../../../assets/img/despidos-colab.svg";
import renunciasSVG from "../../../../../assets/img/renuncias-colab.svg";
import DayPicker from "../../Utils/DayPicker";

import classNames from 'classnames';

Chart.register(...registerables);

export const Visualizar = () => {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    React.useEffect(() => {
        getReports();
    }, [state.startDate, state.endDate]);
    
    // [state.year]);

    const getReports = async () => {
        try {
            onLoad();
           
            const reports = await api.get("recurso/reportes", {
                // year: state.year,
                

                // Cambio en lugar de year, se mandan las fechas para tener un rango
                start_date: state.startDate,
                end_date: state.endDate,
               
                
            });
            onGetReports(reports);
            const now = moment();
            onUpdate(now.format("YYYY-MM-DD HH:mm:ss"));
        } catch (e) {
            console.error(e);
        }
    };

    const onLoad = () => dispatch({ type: actionTypes.loading });
    const onGetReports = (reports = {}) => {
        dispatch({ type: actionTypes.setReports, payload: reports });
    };

    const onUpdate = (value) =>
        dispatch({ type: actionTypes.lastUpdate, payload: value });

    const onDateChange = (name, value) => {
        dispatch({ type: actionTypes.changeDate, payload: { [name]: value } });
    };

    const onChangeParams = ({ name, value }) => {
        onDateChange(name, value);
    };

    const { reports = {}, loading, last_update, startDate, endDate } = state;

    const {
        movimientos_por_mes = { labels: [], datasets: [] },
        altas_bajas_mes = { labels: [], datasets: [] },
        totales = {},
        totales_altas_bajas = {},
        rotacion = 0,
        retencion = 0,
    } = reports;

    const { total = 0, activos = 0, despidos = 0, renuncias = 0 } = totales;
    
    const {
        altas = 0,
        altas_mes = 0,
        bajas = 0,
        bajas_mes = 0,
    } = totales_altas_bajas;

    const getPart = (total, partial) => {
        if (total < 1) return "0%";
        const part = Number((partial * 100) / total);
        return `${part.toFixed()}%`;
    };

    const totalsList = [
        {
            svgUrl: activosSVG,
            alt: "Colaboradores activos",
            color: "#4DCA00",
            totalText: "Colaboradores activos:",
            value: activos,
        },
        {
            svgUrl: despidosSVG,
            alt: "Despidos",
            color: "#CA0000",
            totalText: "Despidos:",
            value: despidos,
        },
        {
            svgUrl: renunciasSVG,
            alt: "Renuncias",
            color: "#007BFF",
            totalText: "Renuncias:",
            value: renuncias,
        },
        {
            svgUrl: totalSVG,
            alt: "total de colaboradores",
            color: "#000",
            totalText: "Total colab.:",
            value: total,
        },
    ];

    const altasBajasList = [
        {
            color: "#2684E2",
            totalText: "Bajas/Mes",
            value: bajas_mes,
        },
        {
            color: "#F4781E",
            totalText: "Bajas/Año",
            value: bajas,
        },
        {
            color: "#0DA140",
            totalText: "Altas/Mes",
            value: altas_mes,
        },
        {
            color: "#670269",
            totalText: "Altas/Año",
            value: altas,
        },
    ];

    return (
        <LoadMask loading={loading} blur={true}>
            <div className="flex row mt-2">
                <div className="col-12">
                    <h2 className="title--blue">Índice de retención y rotación</h2>
                    <hr />
                    {/* <div className="d-flex alig-items-center justify-content-center title--blue"> */}
                        
                        <div className="row alig-items-center justify-content-center">
                        <div className="col-12 col-md-3">
                            <label htmlFor="start_date" className="font-weight-bold m-0">
                                Fecha inicio
                            </label> 
                            <br />
                            <div  style={{ display: "flex" }}>
                                <DayPicker
                                    onChange={(date) => {
                                        onChangeParams({
                                            name: "startDate",
                                            value: date,
                                        });
                                    }}
                                    value={startDate}
                                />
                                <button
                                    className="btn"
                                    style={{ padding: 0 }}
                                    onClick={() =>
                                        onChangeParams({
                                            name: "start_date",
                                            value: "",
                                        })
                                    }
                                >
                                    <i className="material-icons">clear</i>
                                </button>
                            </div>
                        </div>

                        <div className="col-12 col-md-3">
                            <label htmlFor="end_date" className="font-weight-bold m-0">
                                Fecha Fin
                            </label>
                            <br />
                            <div style={{ display: "flex" }}>
                                <DayPicker
                                    onChange={(date) => {
                                        onChangeParams({
                                            name: "endDate",
                                            value: date,
                                        });
                                    }}
                                    value={endDate}
                                />
                                <button
                                    className="btn"
                                    style={{ padding: 0 }}
                                    onClick={() =>
                                        onChangeParams({
                                            name: "end_date",
                                            value: "",
                                        })
                                    }
                                >
                                    <i className="material-icons">clear</i>
                                </button>
                            </div>
                        </div>
                        </div>

                 
                </div>
            </div>
          
            <InformationCard>
                {totalsList.map((item) => (
                    <li key={item.alt}>
                        <img src={item.svgUrl} alt={item.alt} />
                        <span
                            className="label-information"
                            style={{ color: item.color }}
                        >
                            {item.totalText}
                        </span>
                        <span className="label-totals">
                            {item.value} ({getPart(total, item.value)})
                        </span>
                    </li>
                ))}
            </InformationCard>
            <ChartLine
                title={`Índice de retención de colaboradores: ${retencion}%`}
                total={`Total de colaboradores: ${total}`}
                lastUpdate={`Última actualización: ${last_update}`}
                data={movimientos_por_mes}
            />
            <InformationCard>
                {altasBajasList.map((item) => (
                    <li key={item.totalText}>
                        <span
                            className="label-information"
                            style={{ color: item.color }}
                        >
                            {item.totalText}
                        </span>
                        <span className="label-totals">
                            {item.value} ({getPart(total, item.value)})
                        </span>
                    </li>
                ))}
            </InformationCard>
            <ChartLine
                title={`Índice de rotación de colaboradores: ${rotacion}%`}
                total={`Total de colaboradores: ${total}`}
                lastUpdate={`Última actualización: ${last_update}`}
                data={altas_bajas_mes}
            />
        </LoadMask>
    );
};

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const currentDate = new Date();
const startDateDefault = `${currentYear}-01-01`;
// const endDateDefault =  `${currentYear}-12-31`;
const endDateDefault = `${currentYear}-${currentMonth < 10 ? '0' + currentMonth : currentMonth}-${currentDate.getDate()}`;

const initialState = {
    loading: false,
    reports: {},
    last_update: "",
   
    startDate: startDateDefault,
    endDate: endDateDefault,
    // year: new Date().getFullYear(),
};

const actionTypes = {
    loading: "LOADING",
    setReports: "SET_REPORTS",
    lastUpdate: "LAST_UPDATE",
    changeDate: "CHANGE_DATE",
    // changeYear: "CHANGE_YEAR",
};

const reducerObject = (state, payload) => ({
    [actionTypes.setReports]: {
        ...state,
        reports: payload,
        loading: false,
    },
    [actionTypes.loading]: {
        ...state,
        loading: true,
    },
    [actionTypes.lastUpdate]: {
        ...state,
        last_update: payload,
    },
    // [actionTypes.changeYear]: {
    //     ...state,
    //     year: payload,
    // },

    [actionTypes.changeDate]: {
        ...state,
        ...payload,
    },
});

const reducer = (state, action) => {
    return reducerObject(state, action.payload)[action.type] || state;
};
